import { UPDATE_DROPDOWN } from "../actions"

const initialDropdownData = {
  OccurrenceNature: [],
  TypeOfDoctor: [],
  DisablementAccidentDesc: [],
  BicycleNature: [],
  BicycleDamageCause: [],
  BicycleDamagePart: [],
  OtherBenefits: [],
}

const dropdownDataReducer = (state = initialDropdownData, action) => {
  switch (action.type) {
    case UPDATE_DROPDOWN:
      switch (action.dropdownName) {
        case "PA_CLAIM_OCCURRENCE_NATURE":
          return { ...state, OccurrenceNature: action.dropdownItems }
        case "PA_CLAIM_DOCTOR_TYPE": //Type of Doctor
          return { ...state, TypeOfDoctor: action.dropdownItems }
        case "PA_CLAIM_BICYCLE_NATURE":
          return { ...state, BicycleNature: action.dropdownItems }
        case "PA_CLAIM_BICYCLE_DAMAGE_CAUSE":
          return { ...state, BicycleDamageCause: action.dropdownItems }
        case "PA_CLAIM_BICYCLE_DAMAGE_PART":
          return { ...state, BicycleDamagePart: action.dropdownItems }
        case "PA_CLAIM_DISABLEMENT_ACC_DESC":
          return { ...state, DisablementAccidentDesc: action.dropdownItems }
        case "PA_CLAIM_PCE_OTHER_BENEFIT":
          return { ...state, OtherBenefits: action.dropdownItems }
        case "PA_CLAIM_PCC_OTHER_BENEFIT":
          return { ...state, OtherBenefits: action.dropdownItems }
        case "PA_CLAIM_PFS_OTHER_BENEFIT":
          return { ...state, OtherBenefits: action.dropdownItems }
        case "PA_CLAIM_PPA_OTHER_BENEFIT":
          return { ...state, OtherBenefits: action.dropdownItems }
        default:
          //Default set for OtherBenefits also for future new product
          return { ...state, OtherBenefits: action.dropdownItems }
      }
      break
    default:
  }

  return state
}

export default dropdownDataReducer
